import { createContext, useContext } from 'react';
import ConsumerAPIClient from '../Services/consumerService';

const ApiContext = createContext();

export default function ApiProvider({ children }) {
  const api = new ConsumerAPIClient();

  return (
    <ApiContext.Provider value={api}>
      {children}
    </ApiContext.Provider>
  );
}

export function useApi() {
  return useContext(ApiContext);
}